import { RequestServiceGet } from "./services-mia/RequestServiceGet";

export const getUserCredentials = async () => {
    if (
        sessionStorage.getItem("hooliToken") &&
        sessionStorage.getItem("sessionId")
    ) {
        return {
            hooliToken: sessionStorage.getItem("hooliToken"),
            sessionId: sessionStorage.getItem("sessionId"),
        };
    }
    const allowTemporal =
        process.env.REACT_APP_ALLOW_TEMPORAL_SESSION
        
    if (allowTemporal) {
        let userCredentials;
        try {
            userCredentials = await RequestServiceGet({
                service: "TemporalSession",
                params: {
                    merchantId: 23,
                    usuarioId: 5767,
                },
            });
        } catch (err) {
            console.error(`Error: ${err}`);
        }
        if (!userCredentials || !(userCredentials?.length > 0)) {
            console.error(`Fetch failed`);
        }
        sessionStorage.setItem("hooliToken", userCredentials[0].hooliToken);
        sessionStorage.setItem("sessionId", userCredentials[0].sessionId);

        const credentials = {
            hooliToken: userCredentials[0].hooliToken,
            sessionId: userCredentials[0].sessionId
        };
        return credentials;
    }
    return null;
};
